import classNames from 'classnames';
import type React from 'react';
import styles from './index.module.scss';

type UserEnrollmentScheduleStatusIconProps = {
  scheduleStatus: string;
  scheduleStatusText: string;
};

export const UserEnrollmentScheduleStatusIcon: React.FC<
  UserEnrollmentScheduleStatusIconProps
> = ({ scheduleStatus, scheduleStatusText }) => (
  <p className={classNames(styles.scheduleStatus, styles[scheduleStatus])}>
    {scheduleStatusText}
  </p>
);
